import server from "./server";

export const postUserLogin = async ({ data }) => {
  const response = await server().post("/auth/login", data);
  return response.data;
};

export const getCurrentUserApi = async () => {
  const response = await server().get("/auth/me");
  return response.data;
};

export const editCurrentUserApi = async ({ data }) => {
  const response = await server().put("/auth/update", data);
  return response.data;
};

export const updatePasswordApi = async ({ data }) => {
  const response = await server().put("/auth/update-password", data);
  return response.data;
};

export const forgetPasswordApi = async ({ data }) => {
  const response = await server().post("/auth/forgot-password", data);
  return response.data;
};

export const verifyUserApi = async ({ data }) => {
  const response = await server().post("/auth/verify-otp", data);
  return response.data;
};
